export default {"src":"/_next/static/media/loser_right_new.1a208444.svg","height":150,"width":240,"blurWidth":0,"blurHeight":0};